// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_AogXS","foot_link":"index_foot_link_UFrWF","list":"index_list_eMFjF","link":"index_link_5OAwo","copyright":"index_copyright_EXBSd"};